<div class="card">
  <div class="card-body repeat-section">
    @if (field.props?.label && field.props?.label!.length > 0) {
    <h4 class="mb-3">{{field.props?.label! | translate}}</h4>
    }
    @for(element of model[getKey(field)]; track $index){
      @if (allowCollapse) {
      <div class="repeat-section-collapsable mb-3 d-flex align-items-baseline gap-3">
        @if (!isReadMode) {
          <i class="bi bi-x-lg cursor-pointer fs-4 text-danger"
            placement="top"
            tabindex="0"
            [ngbTooltip]="field.props?.['btnRemoveText'] || 'Remove'"
            (click)="removeSection(getKey(field), $index)"
            (keyup.enter)="removeSection(getKey(field), $index)">
          </i>
        }
        <div class="flex-grow-1" ngbAccordion>
          <div ngbAccordionItem (hidden)="onSectionToggle($index, false)" (shown)="onSectionToggle($index, true)">
            <h3 class="mt-0" ngbAccordionHeader [attr.aria-level]="$index + 1">
              <button ngbAccordionButton type="button">
                @if (titles[$index]?.length !== 0) {
                {{ titles[$index] }}
                }
              </button>
            </h3>
            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <form [formGroup]="formArray.at($index)">
                    <formly-form [fields]="getCachedFields($index)" [form]="formArray.at($index)" [model]="element" [options]="options" />
                  </form>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
      @else {
      <form [formGroup]="formArray.at($index)">
        <formly-form [fields]="getCachedFields($index)" [form]="formArray.at($index)" [model]="element" [options]="options" />
      </form>
      @if (!isReadMode) {
      <button class="btn btn-sm btn-danger"
              type="button"
              (click)="removeSection(getKey(field), $index)">
        {{ field.props?.['btnRemoveText'] || 'Remove' }}
      </button>
      <hr>
      }
      }
    }
    @if(!isReadMode){
    <button class="btn btn-primary" type="button" (click)="addNew()">{{ field.props?.['btnText'] }}</button>
    }
  </div>
</div>
